import { store } from '../'

const state = () => ({
    selectedProduct: [],
    selectedForm: [],
    selectedScanned:[],
    productCollection: [],
    createdCollection: [],
    scannedCollection: [],
    notificationCollection: [],
    pendingNotificationCollection: [],
    currentLocation:'',
    ordersToPick: ''
});
const getters = {
    selectedProduct: state => state.selectedProduct,
    selectedForm: state => state.selectedForm,
    selectedForm: state => state.selectedScanned,
    productCollection: state => state.productCollection,
    createdCollection: state => state.createdCollection,
    scannedCollection: state => state.scannedCollection,
    notificationCollection: state => state.notificationCollection,
    pendingNotificationCollection: state => state.pendingNotificationCollection,
    currentLocation: state => state.currentLocation,
    ordersToPick: state => state.ordersToPick
};
const mutations = {
    updateState(state, payload){ 
        //console.log('mutation called: '+ payload.field + ' = ' + payload.value);
        state[payload.field] = payload.value 
        if(payload.field == 'productCollection'){
            //console.log('update storage - ' + JSON.stringify(payload.value));
            localStorage.setItem('productList', JSON.stringify(payload.value));
        }
        if(payload.field == 'createdCollection'){
           // console.log('update creation storage - ' + JSON.stringify(payload.value));
            localStorage.setItem('createList', JSON.stringify(payload.value));
        }
        if(payload.field == 'scannedCollection'){
            //console.log('update scanned storage - ' + JSON.stringify(payload.value));
            localStorage.setItem('scannedList', JSON.stringify(payload.value));
        }
        if(payload.field == 'notificationCollection'){
            //console.log('update notification storage - ' + JSON.stringify(payload.value));
            localStorage.setItem('notificationList', JSON.stringify(payload.value));
        }
        if(payload.field == 'pendingNotificationCollection'){
            //console.log('update notification storage - ' + JSON.stringify(payload.value));
            localStorage.setItem('pendingNotificationList', JSON.stringify(payload.value));
        }
        if(payload.field == 'currentLocation'){
            //console.log('update notification storage - ' + JSON.stringify(payload.value));
            localStorage.setItem('currentLocation', JSON.stringify(payload.value));
        }
        if(payload.field == 'ordersToPick'){
            //console.log('update notification storage - ' + JSON.stringify(payload.value));
            localStorage.setItem('ordersToPick', JSON.stringify(payload.value));
        }
    },
    initialiseStore(state, dispatch) {
        // Check if the ID exists
        if(localStorage.getItem('productList') && localStorage.getItem('productList') != 'undefined') {
           // Replace the state object with the stored item
            //console.log('get products from storage? - '+ JSON.parse(localStorage.getItem('productList')));
            state.productCollection = JSON.parse(localStorage.getItem('productList'));
            //for(const product in state.productCollection){
            //    console.log('product: - '+ Object.entries(state.productCollection[product]));
            //}
        }
        if(localStorage.getItem('createList') && localStorage.getItem('createList') != 'undefined') {
            // Replace the state object with the stored item
             //console.log('get list from storage? - '+ JSON.parse(localStorage.getItem('createList')));
             state.createdCollection = JSON.parse(localStorage.getItem('createList'));
             //for(const createField in state.createdCollection){
             //    console.log('product: - '+ Object.entries(state.createdCollection[createField]));
             //}
         }
         if(localStorage.getItem('scannedList') && localStorage.getItem('scannedList') != 'undefined') {
            // Replace the state object with the stored item
            // console.log('get scanned list from storage? - '+ JSON.parse(localStorage.getItem('scannedList')));
            let currentScannedItems =  JSON.parse(localStorage.getItem('scannedList'));
             store.dispatch('ProductCollection/checkDates', currentScannedItems);
             state.scannedCollection = JSON.parse(localStorage.getItem('scannedList'));
             //for(const scannedField in state.scannedCollection){
             //    console.log('product: - '+ Object.entries(state.scannedCollection[scannedField]));
             //}
         }
         if(localStorage.getItem('notificationList') && localStorage.getItem('notificationList') != 'undefined') {
            // Replace the state object with the stored item
             //console.log('get notification list from storage? - '+ JSON.parse(localStorage.getItem('notificationList')));
             state.notificationCollection = JSON.parse(localStorage.getItem('notificationList'));
             //for(const notificationField in state.notificationCollection){
             //    console.log('product: - '+ Object.entries(state.notificationCollection[notificationField]));
             //}
         }
         if(localStorage.getItem('pendingNotificationList') && localStorage.getItem('pendingNotificationList') != 'undefined') {
            // Replace the state object with the stored item
             //console.log('get notification list from storage? - '+ JSON.parse(localStorage.getItem('pendingNotificationList')));
             state.pendingNotificationCollection = JSON.parse(localStorage.getItem('pendingNotificationList'));
             //for(const notificationField in state.pendingNotificationCollection){
             //    console.log('product: - '+ Object.entries(state.pendingNotificationCollection[notificationField]));
             //}
         }
         if(localStorage.getItem('currentLocation') && localStorage.getItem('currentLocation') != 'undefined') {
            // Replace the state object with the stored item
             //console.log('get location from storage? - '+ JSON.parse(localStorage.getItem('currentLocation')));
             state.currentLocation = JSON.parse(localStorage.getItem('currentLocation'));
             store.dispatch('PowerScan/set', {field:'currentSite', value: state.currentLocation})

         }
         if(localStorage.getItem('ordersToPick') && localStorage.getItem('ordersToPick') != 'undefined') {
            // Replace the state object with the stored item
             //console.log('get location from storage? - '+ JSON.parse(localStorage.getItem('ordersToPick')));
             state.ordersToPick = JSON.parse(localStorage.getItem('ordersToPick'));
         }
    },
    updateProductInCollection(state, payload){
        //console.log('updating collection: productPos:['+ payload.productPosition + '], field: ' + payload.field + ', value: '+payload.value);
        state.productCollection[payload.productPosition][payload.field] = payload.value;
    },
    updateCreationInList(state, payload){
        //console.log('updating list: productPos:['+ payload.productPosition + '], field: ' + payload.field + ', value: '+payload.value);
        state.createdCollection[payload.createdPosition][payload.field] = payload.value;
    },
    updateScannedInList(state, payload){
        //console.log('updating list: productPos:['+ payload.scannedPosition + '], field: ' + payload.field + ', value: '+payload.value);
        state.scannedCollection[payload.scannedPosition][payload.field] = payload.value;
    },
    updateNotificationInList(state, payload){
        //console.log('updating list: productPos:['+ payload.notificationPosition + '], field: ' + payload.field + ', value: '+payload.value);
        state.notificationCollection[payload.notificationPosition][payload.field] = payload.value;
    },
    updatePendingNotificationInList(state, payload){
        //console.log('updating list: productPos:['+ payload.notificationPosition + '], field: ' + payload.field + ', value: '+payload.value);
        state.pendingNotificationCollection[payload.notificationPosition][payload.field] = payload.value;
    },
    updateOrdersToPickInList(state, payload){
        //console.log('updating list: productPos:['+ payload.notificationPosition + '], field: ' + payload.field + ', value: '+payload.value);
        state.ordersToPick[payload.notificationPosition][payload.field] = payload.value;
    }
};
const actions = {
    set({commit}, payload){ 
        //console.log('action called: '+ payload.field + ' = ' + payload.value);
        commit('updateState', {field: payload.field, value: payload.value}) 
    },
    checkDates({state, dispatch}, payload){
        let timeRightNow = Date.now();
        payload.forEach((item) =>{
            let timeDiff = timeRightNow - item.timeAdded;
            let timeElapsed = timeDiff / 1000 / 60 / 60 / 24 ;
            if(timeElapsed > 30){
                dispatch('removeScannedItem', item.sku)
            }
        })
    },
    removeItem({commit, state}, value){
        let tempCollection = state.productCollection;
        let removeIndex = tempCollection.findIndex(x => x.productSku == value)
        //console.log('remove index - '+ removeIndex);
        //console.log('tempCollection before- '+ Object.entries(tempCollection));
        let newArray = tempCollection.slice(0, removeIndex).concat(tempCollection.slice(removeIndex+1, tempCollection.length))
        //console.log('tempCollection after- '+ Object.entries(tempCollection));
        //console.log('newArray - '+ Object.entries(newArray));
        commit('updateState', {field: 'productCollection', value: newArray})
    },
    removeForm({commit, state}, value){
        let tempCollection = state.createdCollection;
        let removeIndex = tempCollection.findIndex(x => x.name == value)
        //console.log('remove index - '+ removeIndex);
        //console.log('tempCollection before- '+ Object.entries(tempCollection));
        let newArray = tempCollection.slice(0, removeIndex).concat(tempCollection.slice(removeIndex+1, tempCollection.length))
        //console.log('tempCollection after- '+ Object.entries(tempCollection));
        //console.log('newArray - '+ Object.entries(newArray));
        commit('updateState', {field: 'createdCollection', value: newArray})
    },
    removeScannedItem({commit, state}, value){
        //console.log("trying to remove - " + value);
        let tempCollection = JSON.parse(localStorage.getItem('scannedList') ) || state.scannedCollection;
        let removeIndex = tempCollection.findIndex(x => x.sku == value)
        //console.log('remove index - '+ removeIndex);
        //console.log('tempCollection before- '+ JSON.stringify(tempCollection))
        let newArray = tempCollection.slice(0, removeIndex).concat(tempCollection.slice(removeIndex+1, tempCollection.length))
        //console.log('tempCollection before- '+ JSON.stringify(tempCollection))
        //console.log('newArray - '+ Object.entries(newArray));
       if(removeIndex != -1){
            commit('updateState', {field: 'scannedCollection', value: newArray})
       }
    },
    removeNotification({commit, state}, value){
        let tempCollection = state.notificationCollection;
        let removeIndex = tempCollection.findIndex(x => x.id == value)
        let newArray = tempCollection.slice(0, removeIndex).concat(tempCollection.slice(removeIndex+1, tempCollection.length))
        commit('updateState', {field: 'notificationCollection', value: newArray})
    },
    removePendingNotification({commit, state}, value){
        let tempCollection = state.pendingNotificationCollection;
        let removeIndex = tempCollection.findIndex(x => x.id == value)
        let newArray = tempCollection.slice(0, removeIndex).concat(tempCollection.slice(removeIndex+1, tempCollection.length))
        commit('updateState', {field: 'pendingNotificationCollection', value: newArray})
    },
    updateItem({commit, state}, payload){
        //console.log('update item: - ' +Object.entries(payload));
        let tempCollection = state.productCollection;
        let product = tempCollection.findIndex(x => x.productSku == payload.sku);
        if (product != -1){
            commit('updateProductInCollection', {productPosition: product, field: payload.field, value: payload.value});
        }
    },
    updateCreatedItem({commit, state}, payload){
        //console.log('update item: - ' +Object.entries(payload));
        let tempCollection = state.createdCollection;
        let product = tempCollection.findIndex(x => x.productSku == payload.sku);
        if (product != -1){
            commit('updateCreationInList', {productPosition: product, field: payload.field, value: payload.value});
        }
    },
    updateScannedItem({commit, state}, payload){
        //console.log('update item: - ' + JSON.stringify(tempCollection));//Object.entries(payload));
        let tempCollection = state.scannedCollection;
        let product = tempCollection.findIndex(x => x.sku == payload.sku);
        if (product != -1){
            commit('updateScannedInList', {productPosition: product, field: payload.field, value: payload.value});
        }
    },
    updateNotificationItem({commit, state}, payload){
        //console.log('update item: - ' + JSON.stringify(tempCollection));//Object.entries(payload));
        let tempCollection = state.notificationCollection;
        let product = tempCollection.findIndex(x => x.sku == payload.sku);
        if (product != -1){
            commit('updateNotificationInList', {productPosition: product, field: payload.field, value: payload.value});
        }
    },
    addFormToStorage({dispatch, state}, payload){
        let tempForm = {};
        let newForm = {'name' : payload.name, 'route': payload.route}
        let currentForm = state.createdCollection;
        //console.log('what it should be - ' + JSON.stringify(newForm))
        for(const item in newForm){
            console.log('item: '+`${item} -> ${newForm[item]}`);
            console.log('item alone: '+ item);
            let itemName = item;
            Object.assign(tempForm, {[itemName]:  newForm[item]});
        };
        //console.log('tempForm: ' + Object.entries(tempForm));
        dispatch('set', {field: 'selectedForm', value: tempForm})
        let tempCreatedCollection = currentForm;
        //console.log('pushing: '+ JSON.stringify(tempForm) + ' into - '+ JSON.stringify(currentForm))
        if(tempCreatedCollection.findIndex(x => x.name == tempForm.name) == -1){
            tempCreatedCollection.push(tempForm);
            dispatch('set', {field: 'createdCollection', value: tempCreatedCollection})
        }else{
            console.log('already exists in storage')
        }
    },
    updateOrdersToPick({commit, state}, payload){
        //console.log('update item: - ' + JSON.stringify(tempCollection));//Object.entries(payload));
        let tempCollection = state.ordersToPick;
        let product = tempCollection.findIndex(x => x.name == payload.name);
        if (product != -1){
            commit('updateOrdersToPickInList', {productPosition: product, field: payload.field, value: payload.value});
        }
    },
    addNotificationToStorage({dispatch, state}, payload){
        let newNotification = payload;
        let currentNotificationCollection = state.notificationCollection;
        //console.log('what it should be - ' + JSON.stringify(newNotification))
        if(currentNotificationCollection.findIndex(x => x.id == newNotification.id) == -1){
            currentNotificationCollection.push(newNotification);
            dispatch('set', {field: 'notificationCollection', value: currentNotificationCollection})
        }else{
            console.log('already exists in storage')
        }
    },
    addPendingNotificationToStorage({dispatch, state}, payload){
        let newNotification = payload;
        let currentNotificationCollection = state.pendingNotificationCollection;
        //console.log('what it should be - ' + JSON.stringify(newNotification))
        if(currentNotificationCollection.findIndex(x => x.id == newNotification.id) == -1){
            currentNotificationCollection.push(newNotification);
            dispatch('set', {field: 'pendingNotificationCollection', value: currentNotificationCollection})
        }else{
            console.log('already exists in storage')
        }
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}